export const ERRORS = {
  WRONG_PAYOUTS: "Wrong payouts data",
};
